import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { GameProvider } from './context/GameContext';
import GamesPage from './pages/GamesPage';
import UpdatesPage from './components/UpdatesPage';
import AboutPage from './components/AboutPage';
import RulesPage from './pages/RulesPage';
import AuthPage from './pages/AuthPage';
import LeaderboardPage from './components/LeaderboardPage';
import AdminPage       from './pages/AdminPage';
import OfflineBanner   from './components/OfflineBanner';
import ErrorBoundary   from './components/ErrorBoundary';
import './App.css';

function AppContent() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return <AuthPage />;

  return (
    <div className="app-wrapper">
      <Routes>
        <Route path="/"        element={<ErrorBoundary><GamesPage /></ErrorBoundary>} />
        <Route path="/games"   element={<ErrorBoundary><GamesPage /></ErrorBoundary>} />
        <Route path="/updates" element={<ErrorBoundary><UpdatesPage /></ErrorBoundary>} />
        <Route path="/about"   element={<ErrorBoundary><AboutPage /></ErrorBoundary>} />
        <Route path="/rules"        element={<ErrorBoundary><RulesPage /></ErrorBoundary>} />
        <Route path="/leaderboard" element={<ErrorBoundary><LeaderboardPage /></ErrorBoundary>} />
        <Route path="/admin"       element={<ErrorBoundary><AdminPage /></ErrorBoundary>} />
        <Route path="*"        element={<ErrorBoundary><GamesPage /></ErrorBoundary>} />
      </Routes>
    </div>
  );
}

function AppShell() {
  const { token } = useAuth();
  return (
    <GameProvider token={token}>
      <AppContent />
    </GameProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <OfflineBanner />
      <AppShell />
    </AuthProvider>
  );
}

export default App;
